<template>
  <v-dialog v-model="config.open" max-width="355" :persistent="persistent" >
    <v-card>
      <v-card-title class="headline">{{titulo}}</v-card-title>
      <v-form v-model="dObs" ref="formdObs">
      
        <v-layout row wrap>
          <v-flex xs12 sm12 md12>
            <v-select
              v-model.number="config.motivoSelecionado"
              :items="listaMotivos"
              item-text="mtMotivo"
              item-value="mtNumero"
              clearable
              class="custom-select"
              :menu-props="{ offsetY: true, minWidth: '300px', left: true }"
              label="Motivo 1"
              @change="onChangeMotivo1"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12 md12 v-if="motivo2Visivel">
            <v-select
              v-model.number="config.motivoSelecionado2"
              :items="listaMotivos2"
              item-text="mtMotivo"
              item-value="mtNumero"
              clearable
              class="custom-select"
              :menu-props="{ offsetY: true, minWidth: '300px', left: true }"
              :disabled="!motivo2Habilitado"
              label="Motivo 2"
              @change="onChangeMotivo2"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12 md12 v-if="motivo3Visivel">
            <v-select
              v-model.number="config.motivoSelecionado3"
              :items="listaMotivos3"
              item-text="mtMotivo"
              item-value="mtNumero"
              clearable
              class="custom-select"
              :menu-props="{ offsetY: true, minWidth: '300px', left: true }"
              label="Motivo 3"
              @change="onChangeMotivo3"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout wrap p-b-10>
          <v-flex xs12 sm6>
            <v-btn @click="$emit('observacaoCancel')">{{labelBtnCancelar}}</v-btn>
          </v-flex>
          <v-flex xs12 sm6>
            <v-btn color="info" @click="observacaoOk()" :loading="isLoading">{{labelBtnOk}}</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidacaoBase from "../plugins/js/ValidacaoBase";
import DocumentosFornecService from "../services/documentosFornecService";
import FamiliaService from "../services/familiaService";
import Vue from 'vue';
export default {
  mixins: [ValidacaoBase],
  props: {//Propriedades que o objeto recebe como parametro
    rules:Array,
    persistent:Boolean,
    permitirMultiplosMotivos: {
      type: Boolean,
      default: true
    },
    config: {
      type: Object,
      default: function() {
        return {
          open: false,
          titulo: "Motivo de Indeferimento",
          obs: null,
          labelBtnCancelar: "Cancelar",
          labelBtnOk: "Rejeitar",
          motivoSelecionado: null,
          motivoSelecionado2: null,
          motivoSelecionado3: null,
          codDocumento: null,
          codGrupo: null,
          numFamilia: null

        };
      }
    },
  },
  data() {//Declaracao de variaveis
    return {
      dObs: true,
      isLoading: false,
      listaMotivos: []
    };
  },
  created() /*Metodo de start do componente*/{
    this.normalizarConfigMotivos();
    this.carregarListaMotivos();
  },
  computed: {//Campos computados
    titulo: function() {
      return (this.config.titulo === this.config.titulo
        ? this.config.titulo
        : "Motivo de Indeferimento");
    },
    labelBtnCancelar: function() {
      return this.config.labelBtnCancelar ? this.config.labelBtnCancelar : "Cancelar";
    },
    labelBtnOk: function() {
      return this.config.labelBtnOk ? this.config.labelBtnOk : "Rejeitar";
    },
     _rules: function() {
      return this.rules ? this.rules : this.validacao.campoObrigatorio;
    },
    motivo2Visivel() {
      return this.permitirMultiplosMotivos && this.config.motivoSelecionado !== null && this.config.motivoSelecionado !== undefined && this.config.motivoSelecionado !== "";
    },
    motivo2Habilitado() {
      return this.config.motivoSelecionado !== null && this.config.motivoSelecionado !== undefined && this.config.motivoSelecionado !== "";
    },
    motivo3Visivel() {
      return this.permitirMultiplosMotivos && this.config.motivoSelecionado2 !== null && this.config.motivoSelecionado2 !== undefined && this.config.motivoSelecionado2 !== "";
    },
    listaMotivos2() {
      return this.listaMotivos.filter(item => item.mtNumero !== this.config.motivoSelecionado);
    },
    listaMotivos3() {
      return this.listaMotivos.filter(item => item.mtNumero !== this.config.motivoSelecionado && item.mtNumero !== this.config.motivoSelecionado2);
    }
  },
  watch: { //Propriedades assistidas
    "config.open": {
      handler(newValue, oldValue) {
        if (newValue) {
          this.normalizarConfigMotivos();
        }
        else {
          this.isLoading = false;
        }
      }
    },
    "config.codDocumento": {
      handler(newValue, oldValue) {
        if (newValue !== null && newValue !== undefined && newValue !== oldValue) {
          this.carregarListaMotivos();
        }
      }
    },
    "config.codGrupo": {
      handler(newValue, oldValue) {
        if (newValue !== null && newValue !== undefined && newValue !== oldValue) {
          this.carregarListaMotivosFamilia();
        }
      }
    },
    "config.numFamilia": {
      handler(newValue, oldValue) {
        if (newValue !== null && newValue !== undefined && newValue !== oldValue) {
          this.carregarListaMotivosFamilia();
        }
      }
    },
    "config.motivoSelecionado": {
      handler(newValue) {
        const normalized = this.normalizarNumero(newValue);
        if (normalized !== newValue) {
          this.config.motivoSelecionado = normalized;
        }
      },
      immediate: true
    },
    "config.motivoSelecionado2": {
      handler(newValue) {
        const normalized = this.normalizarNumero(newValue);
        if (normalized !== newValue) {
          this.config.motivoSelecionado2 = normalized;
        }
      },
      immediate: true
    },
    "config.motivoSelecionado3": {
      handler(newValue) {
        const normalized = this.normalizarNumero(newValue);
        if (normalized !== newValue) {
          this.config.motivoSelecionado3 = normalized;
        }
      },
      immediate: true
    }
  },

  methods: {//Declaracao de todos os metodos
    onChangeMotivo1() {
      this.$nextTick(() => {
        this.config.motivoSelecionado2 = null;
        this.config.motivoSelecionado3 = null;
      });
    },
    onChangeMotivo2(newValue) {
      if (newValue !== null && newValue !== undefined && newValue === this.config.motivoSelecionado) {
        Vue.toasted.error(this.$t("messages.validacao.motivoIndeferimentoDuplicado"));
        this.$nextTick(() => {
          this.config.motivoSelecionado2 = null;
        });
      }
      this.$nextTick(() => {
        this.config.motivoSelecionado3 = null;
      });
    },
    onChangeMotivo3(newValue) {
      if (newValue !== null && newValue !== undefined && (newValue === this.config.motivoSelecionado || newValue === this.config.motivoSelecionado2)) {
        Vue.toasted.error(this.$t("messages.validacao.motivoIndeferimentoDuplicado"));
        this.$nextTick(() => {
          this.config.motivoSelecionado3 = null;
        });
      }
    },
    observacaoOk() {
      if (this.config.motivoSelecionado != null) {
        this.isLoading = true;
        // pega os motivos selecionados
        this.$emit("observacaoOk", {
          motivoSelecionado: this.config.motivoSelecionado,
          motivoSelecionado2: this.config.motivoSelecionado2,
          motivoSelecionado3: this.config.motivoSelecionado3
        });
      }
      else
      {
        Vue.toasted.error(this.$t("messages.validacao.motivoIndeferimento"));
      }
    },
    carregarListaMotivosFamilia(){
      //Se o grupo e numero da familia estão preenchidos
      if (this.config.codGrupo && this.config.numFamilia)
      {
        FamiliaService.getMotivosIndeferimento(this.config.codGrupo,this.config.numFamilia).then(response => { /*resposta do servico*/
          this.listaMotivos = this.normalizarMotivos(response.data); /*dados de retorno*/
        });
      }
    },
    carregarListaMotivos(){
      if (this.config.codDocumento)
      {
        DocumentosFornecService.getMotivosIndeferimento(this.config.codDocumento).then(response => { /*resposta do servico*/
          this.listaMotivos = this.normalizarMotivos(response.data); /*dados de retorno*/
        });
      }
    },
    normalizarConfigMotivos() {
      this.config.motivoSelecionado = this.normalizarNumero(this.config.motivoSelecionado);
      this.config.motivoSelecionado2 = this.normalizarNumero(this.config.motivoSelecionado2);
      this.config.motivoSelecionado3 = this.normalizarNumero(this.config.motivoSelecionado3);
    },
    normalizarMotivos(motivos) {
      return motivos.map(item => ({
        ...item,
        mtNumero: this.normalizarNumero(item.mtNumero)
      }));
    },
    normalizarNumero(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      const numero = Number(value);
      return String(value).trim() !== "" && !isNaN(numero) ? numero : value;
    },
  }
};
</script>

<style scoped>
.v-select {
  max-width: 100%; /* Ajuste esse valor conforme necessário */
}

.v-select .v-list-item__title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>